import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import HomePage from "./Components/home/home";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HomePage />
  </React.StrictMode>
);
